import api from '@/services/Api';

class NotificationService {
  async getNotificationCount() {
    const response = await api.get('/distributor/notification/count')
    return response.data
  }

  async getNotificationList(page, limit) {
    const response = await api.get(
      '/distributor/notification/list?'
      + 'page=' + page
      + "&limit=" + limit)
    return response.data
  }

  async updateNotificationToOpen(notificationTechnicalId) {
    const response = await api.put(
      '/distributor/notification/open/' + notificationTechnicalId)
    return response.data
  }

  async updateNotificationToHidden(notificationTechnicalId) {
    const response = await api.put(
      '/distributor/notification/hide/' + notificationTechnicalId)
    return response.data
  }
}

export default new NotificationService()
